<template>
  <div class="add_playlist_form hide">
    <form>
      <h6>Add new playlist</h6>
      <input type="text" placeholder="Enter playlist name" autocomplete="off" />
      <div class="form_button_controls">
        <span class="cancelPlaylistForm">Cancel</span>
        <span>Add</span>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "AddToPlaylistForm"
};
</script>

<style>
</style>